import React from "react";
import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Label from "../../../../components/FormComponents/Label";
import MultiSelectBox from "../../../../components/FormComponents/MultiSelectBox";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";
import { fileFormats } from "../../../../utils/Config/DefaultConfig/fileFormats";

const EditFile = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };

  const options = [{ id: "base64", name: "base64" }];
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <SingleSelectBox
          options={[
            { name: "Default", value: "default" },
            { name: "Drag and Drop", value: "drag_and_drop" }
          ]}
          valueKey="value"
          labelKey={["name"]}
          selectedData={editFieldData?.layout_type || ""}
          onChange={(selected) => handleChangeInput("layout_type", selected?.value || "")}
          label="Select Layout"
          placeholder="Select Layout"
          isSearch
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          // label="Allow from cabinet"
          label={getLabelForKey("show_cabinet")}
          checked={editFieldData.show_cabinet}
          name="show_cabinet"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("backend_validation")}
        checked={editFieldData.validate.backend_validation}
        name="backend_validation"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
      />
      <Input
        type="checkbox"
        // label="Upload on Image Select"
        label={getLabelForKey("upload_on_select")}
        checked={editFieldData.upload_on_select}
        name="upload_on_select"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeInput(target.name, target.checked)}
      />
      <div className="field_horizontal_container">
        <div className="w_50 flex_column gap_2">
          <Label>Number of files</Label>
          <div className="field_horizontal_container">
            <div className="flex_column gap_1">
              <Input
                type="number"
                value={editFieldData.fileMinRange}
                name="fileMinRange"
                onChange={({ target }) => handleChangeInput(target.name, target.value)}
              />
              <span>Min</span>
            </div>
            <div className="flex_column gap_1">
              <Input
                type="number"
                value={editFieldData.fileMaxRange}
                name="fileMaxRange"
                onChange={({ target }) => handleChangeInput(target.name, target.value)}
              />
              <span>Max</span>
            </div>
          </div>
        </div>

        <div className="w_50 flex_column gap_2">
          <Label>File Size</Label>
          <div className="flex_column gap_1 w_50">
            <Input
              type="number"
              value={editFieldData.fileMaxSize}
              name="fileMaxSize"
              onChange={({ target }) => handleChangeInput(target.name, target.value)}
            />
            <span>Max</span>
          </div>
        </div>
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("filePrefix")}
          value={editFieldData.filePrefix}
          name="filePrefix"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
      <div className="field_horizontal_container">
        <MultiSelectBox
          options={fileFormats}
          valueKey="id"
          labelKey={["name"]}
          selectedData={editFieldData.acceptable_formats || []}
          onChange={(selected) => handleChangeInput("acceptable_formats", selected)}
          label="Acceptable Formats"
          placeholder="Select Formats"
          isSearch
        />
      </div>
      <div className="field_horizontal_container">
        <SingleSelectBox
          selectedData={editFieldData.storage}
          options={options}
          onChange={(a) => handleChangeInput("storage", a.id)}
          label={getLabelForKey("storage")}
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditFile;
